module.exports = __webpack_public_path__ + "static/img/图层 31.85109f16.png";